import '../styles/main.sass';
import Stylie from './stylie';

window.stylie = new Stylie(document.getElementById('stylie'));
